<template>
  <feather-icon
    :icon="icon"
    :svgClasses="{
      status_icon: true,
      completed: this.type === 'completed',
      not_completed: this.type !== 'completed',
    }"
  />
</template>

<script>
export default {
  computed: {
    icon() {
      return this.type === 'completed' ? 'CheckIcon' : 'XIcon';
    },
  },
  props: ['type'],
};
</script>
<style scoped lang="scss">
.status_icon {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  padding: 2px;
}
.status_icon.completed {
  border: 2px solid rgba(var(--vs-primary), 1);
  color: rgba(var(--vs-primary), 1);
}
.status_icon.not_completed {
  border: 2px solid rgba(var(--vs-danger), 1);
  color: rgba(var(--vs-danger), 1);
}
.prework_icon.large_icon .status_icon {
  width: 40px !important;
  height: 40px !important;
}
</style>
